import React from 'react';
import { Plus, X } from 'lucide-react';
import './DynamicFieldList.css';

interface DynamicFieldListProps<T> {
  title: string;
  items: T[];
  readOnly?: boolean;
  viewMode?: boolean; // Deprecated, use readOnly instead
  renderItem: (item: T, index: number) => React.ReactNode;
  onAdd: () => void;
  onRemove: (index: number) => void;
  addButtonText?: string;
  emptyMessage?: string;
  disableAdd?: boolean;
}

function DynamicFieldList<T>({
  title,
  items,
  readOnly,
  viewMode, // Deprecated
  renderItem,
  onAdd,
  onRemove,
  addButtonText = 'Add',
  emptyMessage,
  disableAdd = false,
}: DynamicFieldListProps<T>) {
  // Support both readOnly and deprecated viewMode prop
  const isReadOnly = readOnly ?? viewMode ?? false;
  
  return (
    <div className="dynamic-section">
      <div className="section-header">
        <h3>{title}</h3>
        {!isReadOnly && !disableAdd && (
          <button onClick={onAdd} className="btn btn-outline btn-sm">
            <Plus size={16} /> {addButtonText}
          </button>
        )}
      </div>
      {items.length === 0 && emptyMessage && (
        <p className="empty-message">{emptyMessage}</p>
      )}
      {items.map((item, index) => (
        <div key={index} className="dynamic-item-wrapper">
          {renderItem(item, index)}
        </div>
      ))}
    </div>
  );
}

export default DynamicFieldList;
